import { useEffect, useState } from "react";
import { Model } from "../../../models/model";

import iconDrive from "../google/driveIcon.svg";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID;

const GoogleDrivePicker = ({ onSelect }) => {
  const [pickerReady, setPickerReady] = useState(false);

  useEffect(() => {
    // Si ya está cargado
    if (window.gapi) {
      window.gapi.load("picker", {
        callback: () => {
          setPickerReady(true);
        },
      });

      return;
    }

    const script = document.createElement("script");

    script.src = "https://apis.google.com/js/api.js";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      window.gapi.load("picker", {
        callback: () => {
          setPickerReady(true);
        },
      });
    };

    document.body.appendChild(script);
  }, []);

  const openPicker = async () => {
    if (!pickerReady) {
      console.log("Google Picker todavía no está listo");
      return;
    }

    try {
      // Pedimos al backend un access token temporal
      const result = await Model.getOne({
        url: "google/drive/picker-token",
      });

      const accessToken = result?.accessToken;

      if (!accessToken) {
        console.error("No se recibió accessToken");
        return;
      }

      const view = new window.google.picker.DocsView(
        window.google.picker.ViewId.DOCS,
      )
        .setIncludeFolders(true)
        .setSelectFolderEnabled(false);

      const picker = new window.google.picker.PickerBuilder()
        .setDeveloperKey(GOOGLE_API_KEY)
        .setAppId(GOOGLE_APP_ID)
        .setOAuthToken(accessToken)
        .addView(view)
        .setTitle("Seleccionar documento")
        .setCallback((data) => {
          if (data.action === window.google.picker.Action.PICKED) {
            const file = data.docs[0];

            // console.log("Archivo seleccionado:", file);

            onSelect({
              driveFileId: file.id,
              nombre: file.name,
              mimeType: file.mimeType,
              url: file.url,
              embedUrl: file.embedUrl,
              sizeBytes: file.sizeBytes,
              parentId: file.parentId,
              iconUrl: file.iconUrl,
            });
          }

          if (data.action === window.google.picker.Action.CANCEL) {
            console.log("Usuario canceló");
          }
        })

        .build();
      picker.setVisible(true);
    } catch (error) {
      console.error("Error abriendo Google Picker:", error);
    }
  };

  return (
    <button
      type="button"
      onClick={openPicker}
      disabled={!pickerReady}
      className="btn mt-2 border cursor-pointer"
    >
      {pickerReady ? (
        <span className="flex">
          <img src={iconDrive} alt="Google drive" className="w-6" />
          <label className="ms-2">Seleccionar desde Google Drive</label>
        </span>
      ) : (
        "Cargando Google Drive..."
      )}
    </button>
  );
};

export default GoogleDrivePicker;
